import { Component, ContentChild, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-sidebar-item',
  standalone: true,
  imports: [],
  templateUrl: './sidebar-item.component.html',
  styleUrl: './sidebar-item.component.scss'
})
export class SidebarItemComponent {
  @Input() isActive: boolean = false;
  @Input() isSelected: boolean = false;

  @ContentChild('subtitle') subtitleSlot?: ElementRef;

  get hasSubtitle(): boolean {
    return !!this.subtitleSlot;
  }
}
